import { render, staticRenderFns } from "./page02.vue?vue&type=template&id=436ba998&scoped=true&"
import script from "./page02.vue?vue&type=script&lang=js&"
export * from "./page02.vue?vue&type=script&lang=js&"
import style0 from "./page02.vue?vue&type=style&index=0&id=436ba998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436ba998",
  null
  
)

export default component.exports